<template>
  <div class="report-item">
    <div class="report-item__data">
      <div class="report-item__name">
        <router-link :to="{ name: 'olap-report', params: { id: report.id }, query: { code: code } }">{{
          report.name
        }}</router-link>
      </div>
      <div class="report-item__meta">
        <div v-if="report.responsible" class="report-item__responsible">
          <svg-icon class="icon" :size="16" name="user" />
          {{ report.responsible.name }}
        </div>
      </div>
    </div>
    <div class="report-item__actions">
      <c-button :id="`report-actions-${report.id}`" class="report-item__menu" tabindex="-1" size="iconic" icon="menu" />
      <c-button
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: 'Переместить',
          placement: 'top',
        }"
        class="report-item__move"
        size="iconic"
        icon="arrows-constructor"
      />

      <dropdown-menu
        :target="`report-actions-${report.id}`"
        :list="actions"
        custom-class="report-menu"
        @click="onClick"
      />
    </div>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import DropdownMenu from "@/components/dropdown-menu";
import SvgIcon from "@/components/svg-icon";

const actions = (report) =>
  [
    report.hasDescription && {
      id: "showDescription",
      text: "Посмотреть описание",
      icon: "comment",
    },
    {
      id: "config",
      text: "Параметры построения отчета",
      icon: "settings",
    },
    {
      id: "edit",
      text: "Редактировать настройки",
      icon: "pencil",
    },
    {
      id: "remove",
      text: "Удалить",
      icon: "bin",
      iconColor: "secondary",
    },
  ].filter(Boolean);

export default {
  components: { CButton, DropdownMenu, SvgIcon },
  props: ["report", "code"],
  computed: {
    actions() {
      return actions(this.report);
    },
  },
  methods: {
    onClick(action) {
      this.$emit(action.id, this.report);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.report-item {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding: 8px 16px;
  // padding-right: 10px;
  border: 1px solid $color-border-light;
  cursor: pointer;

  &__data {
    flex-grow: 1;
  }

  &__name {
    font-size: 13px;
    margin-right: 16px;
    flex-grow: 1;
  }

  &__meta {
    margin-right: 16px;
    font-size: 11px;
    color: $color-label;
  }

  &__responsible {
    display: flex;
    align-items: center;
    margin-top: 4px;

    .icon {
      margin-right: 10px;
    }
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  &__menu {
    margin-right: 15px;
  }

  @include bootstrapMd {
    &__data {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &__meta {
      margin-right: 30px;
    }
    &__responsible {
      margin-top: 0;
    }
  }
}
</style>

<style>
.report-menu {
  max-width: 300px !important;
}
</style>
